const API_XAPI_REQUEST = 'API_XAPI_REQUEST';
const API_XAPI_SUCCESS = 'API_XAPI_SUCCESS';
const API_XAPI_FAILURE = 'API_XAPI_FAILURE';

export const xapiRequest = payload => ({
  type: API_XAPI_REQUEST,
  payload,
});

export const xapiSuccess = payload => ({
  type: API_XAPI_SUCCESS,
  payload,
});

export const xapiFailure = payload => ({
  type: API_XAPI_FAILURE,
  payload,
});

const initialState = {
  xapiType: null,
  type:null,
  isFetched: false,
  fetching: false,
  error: null,
  xapi: null,
};

export function xapiReducer(state = initialState, action) {
  switch (action.type) {
    case API_XAPI_REQUEST:
     
      return {
        ...state,
        xapiType: action.payload.xapiType,
        type: action.payload.type,
        fetching: true,
      };
    case API_XAPI_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        xapi: action.payload,
      };
    case API_XAPI_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,
        xapi: null,
      };
    default:
      return state;
  }
}
